import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface CopyableProcessNumberProps {
  number: string;
  className?: string;
  /** 'inline' = ícone ao lado do texto (padrão), 'badge' = estilo pill com fundo */
  variant?: 'inline' | 'badge';
  prefix?: string;
}

export function CopyableProcessNumber({
  number,
  className = '',
  variant = 'inline',
  prefix,
}: CopyableProcessNumberProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(number).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const label = prefix ? `${prefix}${number}` : number;

  if (variant === 'badge') {
    return (
      <button
        type="button"
        onClick={handleCopy}
        title={copied ? 'Copiado!' : 'Clique para copiar'}
        className={`inline-flex items-center gap-1.5 font-mono text-xs px-2 py-0.5 rounded-sm bg-muted hover:bg-accent hover:text-accent-foreground text-foreground transition-colors group cursor-pointer select-none ${className}`}
      >
        <span>{label}</span>
        {copied
          ? <Check className="w-3 h-3 text-primary shrink-0" />
          : <Copy className="w-3 h-3 text-muted-foreground group-hover:text-foreground shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
        }
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={copied ? 'Copiado!' : 'Clique para copiar'}
      className={`inline-flex items-center gap-1 font-mono hover:text-foreground transition-colors group cursor-pointer select-none ${className}`}
    >
      <span>{label}</span>
      {copied
        ? <Check className="w-3.5 h-3.5 text-primary shrink-0" />
        : <Copy className="w-3.5 h-3.5 text-muted-foreground group-hover:text-foreground shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
      }
    </button>
  );
}
